import { Inject, Injectable } from '@angular/core';


import { SVG, Svg, Image } from '@svgdotjs/svg.js';
import { PartInfo } from 'app/collage-designer/collage-designer-config';
import { StageUtils } from 'app/core/utils.stage';
import { DesignStepService
       } from 'collage-designer/design-step/design-step.service';
import { StageService } from 'collage-designer/stage/stage.service';
import { StageConstants } from 'core/constants';
import { QualityRating } from './quality-rating';

@Injectable()
export class ImageQualityRatingService
{
  public constructor(
      @Inject(DesignStepService) private designStepService: DesignStepService,
      @Inject(StageService) private stageService: StageService)
  {}

  public readQualityRating(image: Image): number|undefined
  {
    const encodedBounds = image.attr(StageConstants.ATTRIBUTE_BOUNDING_BOX);
    if (! encodedBounds) {
      return undefined;
    }

    const bounds = JSON.parse(
      image.attr(StageConstants.ATTRIBUTE_BOUNDING_BOX));

    const wrapper = (<any>image).parent() as Svg;

    this.updateImageQualityRating(wrapper, bounds.width);

    return parseInt(image.node.getAttribute(
        StageConstants.ATTRIBUTE_QUALITY_RATING), 10);
  }

  private updateImageQualityRating(element: Svg, imageWidth: number): void
  {
    element.find('image').at(0).attr(
        StageConstants.ATTRIBUTE_QUALITY_RATING,
        this.calculateImageQualityRating(element, imageWidth));
  }

  private calculateViewboxFactor(info: PartInfo): number
  {
    const referenceSide = (
      this.stageService.getCurrentStageState().stageConfig.rotation % 180 === 0
        ? info.config.width
        : info.config.height);

    return referenceSide / StageUtils.originalDimensions(info.doc).width;
  }

  private findContainingPart(wrapper: Svg): PartInfo
  {
    for (const parent of wrapper.parents()) {
      const partId = parent.attr(StageConstants.ATTRIBUTE_PART_ID);
      const fallbackPart = this.designStepService.getDesignablePart();

      if (partId) {
        return {
          config: this
            .designStepService
            .getParts()
            .filter(p => p.id === partId)[0] || fallbackPart,
          doc: parent as Svg,
        };
      }
    }

    return {
      config: this.designStepService.getPart(),
      doc: (<any>wrapper).root() as Svg,
    };
  }

  private calculateImageQualityRating(
      wrapper: Svg, imageWidth: number): number
  {
    let qualityInPercent = 1;
    if (!this.designStepService
          .getDesignStepConfig().imagePlaceholdersSettings.disableImageRating) {
      const info = this.findContainingPart(wrapper);
      const factor = this.calculateViewboxFactor(info);
      let targetWidth = wrapper.width() as number;
      let group = (<any>wrapper).parent();
      while (group && group.node.tagName === 'g') {
        targetWidth = targetWidth * group.transform().scaleX;
        group = group.parent();
      }
      targetWidth = targetWidth * factor;

      qualityInPercent = imageWidth / targetWidth;
    }
    return QualityRating.getQualityByPercent(qualityInPercent);
  }
}
